import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { EdwardColors } from 'enums';
import '../AppTheme/index';
import { borderRadiusBox } from 'components/AppTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: (props: any) => ({
      alignItems: 'stretch',
      '& > div > div:not(.DETAIL)': {
        marginRight: props.simple ? 0 : theme.spacing(2),
        height: '100%',
        [theme.breakpoints.down('sm')]: {
          marginRight: props.simple ? 0 : theme.spacing(1),
        },
        [theme.breakpoints.down('xs')]: {
          marginRight: 0,
        },
      },
      '& > div:last-child > div': { marginRight: 0 },
      '& > div.SHORT_TERM > div': { marginRight: 0 },
    }),
    bucket: (props: any) => ({
      borderRadius: props.activated || !props.simple ? `${theme.borderRadius.box} ${theme.borderRadius.box} 0 0` : 0,
      cursor: 'pointer',
      boxShadow: !props.activated ? 'none' : '0 0 10px 1px rgba(0,0,0,0.13)',
      backgroundColor: props.activated ? theme.palette.background.paper : theme.palette.grey['200'],
      transform: props.activated
        ? props.simple
          ? 'translateY(4%)'
          : 'none'
        : props.simple
        ? 'translateY(24%)'
        : 'none',
      transition: '.3s all',
      [theme.breakpoints.down('xs')]: {
        transform: 'none',
      },
    }),
    tabWrapper: {
      position: 'relative',
      '& ._activeCurtain': {
        width: 'calc(100% + 28px)',
        height: '28px !important',
        position: 'absolute',
        left: '-14px',
        bottom: '-28px',
        background: '#fff',
      },
      '&:first-child ._activeCurtain': { left: 0 },
      '&:last-child:not(:only-child) ._activeCurtain': { left: '-28px' },
    },
    active: {
      zIndex: 1,
    },
    inactive: {
      color: EdwardColors.GRAY_MEDIUM,
    },
    portfolioTitle: {
      marginBottom: 0,
      fontSize: '1rem',
      '& span': { fontSize: '14px', fontWeight: 400, color: '#666' },
    },
    portfolioValue: {
      color: '#666',
      fontSize: '16px',
      marginBottom: theme.spacing(2),
    },
    header: (props: any) => ({
      '& .MuiTypography-root': { position: 'relative' },
      '& > div > h2': {
        position: 'relative',
        padding: props.simple ? 0 : theme.spacing(2, 2, 0, 2),
        marginBottom: props.simple ? undefined : 0,
        borderBottom: props.simple ? 'none' : 'solid #eee 2px',
        overflow: 'visible',
        fontWeight: 800,
        //fontSize: props.active === false ? '1.1rem' : undefined,
        fontSize: '18px',
        lineHeight: props.active === false ? '2rem' : undefined,
        '&:before': props.simple
          ? undefined
          : {
              display: 'block',
              content: '""',
              width: '100%',
              height: props.activated ? 'calc(100% + 72px)' : '100%',
              transition: 'height 250ms',
              backgroundColor: props.bgColor,
              position: 'absolute',
              left: 0,
              top: 0,
            },
        '&:after': {
          display: 'block',
          content: '""',
          width: '100%',
          height: '2px',
          position: 'absolute',
          left: 0,
          top: props.activated ? 'calc(100% + 74px)' : 'calc(100% + 2px)',
          transition: 'top 250ms',
          backgroundColor: props.bgColor,
        },
        '& span': { position: 'relative' },
        '@media (max-width: 740px)': {
          '&._active:before': { height: 'calc(100% + 92px)' },
          '&._active:after': { top: 'calc(100% + 94px)' },
        },
      },
      '& p': {
        fontSize: '14px',
      },
      '& > div > div': {
        padding: theme.spacing(1, 2, 0, 2),
        '& h2': { marginBottom: 0, fontWeight: props.simple ? undefined : '800', fontSize: '18px' },
      },
      position: 'relative',
      padding: props.simple ? theme.spacing(1) : 0,
      paddingTop: props.simple ? theme.spacing(2) : 0,
      paddingLeft: props.simple ? theme.spacing(2) : 0,
      paddingRight: props.simple ? theme.spacing(2) : 0,
      paddingBottom: theme.spacing(props.simple ? 2 : 1),

      '& .MuiTypography-h2:first-child': {
        display: 'inline-block',
        width: '100%',
      },
      [theme.breakpoints.down('xl')]: {
        '& .MuiTypography-h2:first-child': { minHeight: props.simple ? '3rem' : '0' },
      },
      [theme.breakpoints.down('md')]: {
        '& .MuiTypography-h2': { fontSize: '1.2rem' },
        '& .MuiTypography-h2:first-child': { minHeight: props.simple ? '3rem' : '2rem' },
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(props.simple ? 2 : 0),
        paddingRight: theme.spacing(props.simple ? 2 : 0),
        '& .MuiTypography-h2': { fontSize: props.simple ? '1rem' : '1.2rem' },
        '& .MuiTypography-h2:first-child': {
          minHeight: '4.5rem',
        },
      },
      '@media (max-width: 740px)': {
        '& p.MuiTypography-root': { minHeight: '48px' },
      },
      [theme.breakpoints.down('xs')]: {
        '& .MuiTypography-h2': { fontSize: '19px' },
        paddingLeft: theme.spacing(props.simple ? 2 : 0),
        paddingRight: theme.spacing(props.simple ? 2 : 0),
        '& .MuiTypography-h2:first-child': {
          minHeight: 0,
        },
      },
    }),
    headerBg: (props: any) => ({
      backgroundColor: props.bgColor,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: props.activated && !props.simple ? '100%' : theme.spacing(1),
      zIndex: 0,
    }),
    balance: {
      fontSize: theme.typography.fontSize * 2,
      marginTop: theme.spacing(2),
      textAlign: 'right',
    },
    risk: {
      fontSize: '14px',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.9rem',
      },
    },
    body: (props: any) => ({
      padding: theme.spacing(2),
      backgroundColor: 'transparent',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(props.simple ? 2 : 1),
        paddingRight: theme.spacing(props.simple ? 2 : 1),
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
      position: 'relative',
      overflow: 'visible',
      zIndex: 1,
      '&:after': {
        position: 'absolute',
        display: 'block',
        content: '""',
        width: '100%',
        height: '10px',
        background: '#fff',
        left: 0,
        bottom: '-1px',
        opacity: props.activated ? 1 : 0,
        transition: '.5s opacity',
      },
    }),
    bodyRow: (props: any) => ({
      minHeight: '34px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
      borderBottom: `1px solid #d2d3d5`,
      lineHeight: '26px',
      '& > span:last-child, & > button:last-child': {
        flexGrow: 1,
        textAlign: 'end',
        fontSize: '14px',
        fontWeight: 900,
      },
      '&.button': {
        paddingBottom: '10px',
        borderBottom: 'none',
        fontSize: '14px',
        fontWeight: 900,

        '& .MuiButton-root': {
          transition:
            'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
          '&.MuiButton-outlined': {
            borderRadius: 0,
          },
        },
        '@media (max-width: 740px)': {
          '& button': {
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5),
          },
          '& button .MuiButton-label': {
            fontSize: '12px',
          },
        },
      },
      [theme.breakpoints.down('md')]: {
        minHeight: '3.5rem',
      },
      [theme.breakpoints.down('xs')]: {
        minHeight: 0,
      },
      '& label > div': { margin: 0 },
    }),
    strategy: {
      '@media (max-width: 1240px)': {
        minHeight: '83px !important',
      },
      '@media (max-width: 660px)': {
        minHeight: '83px !important',
      },
      [theme.breakpoints.down('xs')]: {
        minHeight: '0 !important',
      },
    },
    tabsSection: {
      width: '100%',
      position: 'relative',
      boxShadow: '0 0 10px 1px rgba(0,0,0,0.13)',
      borderRadius: borderRadiusBox,
      margin: 0,
      '&.BUCKET_DETAIL, &.BUCKET_DETAIL > div': {
        borderRadius: borderRadiusBox,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
    },
    tooltip: {
      background: 'transparent',
    },
    negativeMargin: {
      margin: -13,
    },
    inlineTabContent: {
      '& span': { flexDirection: 'row' },
    },
    bucketWrapper: {
      minHeight: '100%',
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(2),
      },
    },
    bucketsSwitch: {
      [theme.breakpoints.down('xs')]: {
        '& .BUCKET_DETAIL': { order: 2 },
        '& .LONG_TERM': { order: 1 },
        '& .MID_TERM': { order: 3 },
        '& .SHORT_TERM': { order: 5 },
        '&.LONG_TERM .BUCKET_DETAIL': { order: 2 },
        '&.MID_TERM .BUCKET_DETAIL': { order: 4 },
        '&.SHORT_TERM .BUCKET_DETAIL': { order: 6 },
      },
      '@media (max-width: 339px)': {
        marginLeft: -theme.spacing(1),
        marginRight: -theme.spacing(1),
        width: `calc(100% + ${theme.spacing(2)}px)`,
      },
    },
    bucketsSelect: {
      margin: theme.spacing(-1, -1, 1, -1),
      width: `calc(100% + ${theme.spacing(2)}px)`,
      paddingBottom: '2px',
      borderTopLeftRadius: borderRadiusBox,
      borderTopRightRadius: borderRadiusBox,
      overflow: 'hidden',
      '& .MuiInputBase-root': {
        fontSize: '20px',
      },
      '& .MuiOutlinedInput-root, & .MuiSelect-outlined': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      '& .MuiSelect-root': {
        padding: theme.spacing(3, 2, 1, 2),
        fontWeight: 500,
        [theme.breakpoints.down('xs')]: {
          fontSize: '19px',
        },
      },
      '& .MuiSelect-icon': {
        top: 'calc(50% - 10px)',
        width: '2rem',
        height: '2rem',
      },

      '&.total': {
        borderBottom: `solid #000 2px`,
        '& .MuiSelect-select': {
          background: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        '& .MuiSelect-icon': {
          color: '#ccc',
        },
      },
      '&.K3': {
        borderBottom: `solid ${EdwardColors.SECONDARY} 2px`,
        '& .MuiSelect-select': {
          background: EdwardColors.SECONDARY,
        },
      },
      '&.K2': {
        borderBottom: `solid ${EdwardColors.DARK} 2px`,
        '& .MuiSelect-select': {
          background: EdwardColors.DARK,
        },
      },
      '&.K1': {
        borderBottom: `solid ${EdwardColors.MEDIUM} 2px`,
        '& .MuiSelect-select': {
          background: EdwardColors.MEDIUM,
        },
      },
    },
    pieWrapper: {
      width: '100%',
    },
    hoverFix: {
      '@media (hover: none)': {
        '&:hover': {
          backgroundColor: `#000 !important`,
        },
        '&.MuiButton-outlinedSecondary:hover': {
          backgroundColor: `#fff !important`,
        },
      },
    },
    riskChange: (props: any) => ({
      color: props.active ? EdwardColors.WARNING : EdwardColors.GRAY_MEDIUM,
      fontWeight: 'bold',
    }),
    riskChangeSlider: (props: any) => ({
      '& .MuiSlider-rail, & .MuiSlider-track': {
        backgroundColor: props.active ? EdwardColors.WARNING : EdwardColors.GRAY_MEDIUM,
        height: '4px',
        marginTop: '-1px',
      },
      '& .MuiSlider-valueLabel > span': {
        backgroundColor: props.active ? EdwardColors.WARNING : EdwardColors.GRAY_MEDIUM,
        '& > span': { color: '#fff' },
      },
      '& .MuiSlider-mark': { opacity: 1, backgroundColor: '#eee', height: '6px', marginTop: '-2px' },
      '& .MuiSlider-thumb': { color: props.active ? EdwardColors.WARNING : EdwardColors.GRAY_MEDIUM },
    }),
    dummy: {
      opacity: 0,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
);

export const useSliderStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.black,
    },
    valueLabel: {
      color: theme.palette.primary.main,
    },
  }),
);

export const useDevelopmentStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainWrapper: {
      background: theme.palette.common.white,
      zIndex: 1,
      marginTop: -1,
      paddingTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      alignItems: 'flex-start',

      [theme.breakpoints.down('md')]: {
        paddingTop: theme.spacing(0),
      },
      '& .MuiSelect-nativeInput': { border: 'none' },
      '& .MuiTextField-root fieldset, & .MuiTextField-root fieldset': { border: 'none' },
    },

    graph: {
      //order: 0,
      //[theme.breakpoints.down('md')]: { order: 1 },
      '& .highcharts-tooltip path': {
        display: 'none',
      },

      '& ._hover:hover': {
        zIndex: 1000,
      },
      '& ._tooltip': {
        display: 'block',
        width: '100%',
        '& > span ': {
          background: '#f8f8f8',
          boxShadow: '0 0 10px 1px rgba(0,0,0,0.13)',
          borderRadius: borderRadiusBox,
          padding: theme.spacing(1),
        },
        '& table': {
          margin: '0 auto',
          fontFamily: 'Roboto, sans-serif',
          borderCollapse: 'collapse',
          '& ._dot': {
            fontSize: '40px',
            lineHeight: '23px',
          },
          '& td': {
            lineHeight: '21px',
            padding: '2px 6px',
            verticalAlign: 'middle',
            '@media (max-width: 400px)': {
              padding: '2px',
            },
          },
        },
      },
      '& .noTooltip ._tooltip, & .noTooltip .highcharts-crosshair': {
        display: `none !important`,
      },
      '& .highcharts-legend': { zIndex: 1 },

      [theme.breakpoints.down('xs')]: {
        padding: '0 8px',
      },
    },

    filter: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      position: 'relative',
      zIndex: 1,
      //marginTop: '-58px',
      //marginRight: '335px',
      paddingLeft: theme.spacing(2),
      '& > span': {
        display: 'inline-flex',
        fontSize: '12px',
        textWrap: 'nowrap',
        lineHeight: '58px',
      },
      //'& fieldset > div': { margin: theme.spacing(0, 0, 0, 2) },
      '& .filter_DEPOSIT .MuiCheckbox-root, & .filter_PERIODIC_DEPOSIT .MuiCheckbox-root': {
        color: EdwardColors.GREEN,
        [theme.breakpoints.down('xs')]: { padding: '4px' },
      },
      '& .filter_TARGET .MuiCheckbox-root': {
        color: EdwardColors.DARK,
        [theme.breakpoints.down('xs')]: { padding: '4px' },
      },
      '& .filter_WITHDRAWAL .MuiCheckbox-root': {
        color: EdwardColors.WARNING,
        [theme.breakpoints.down('xs')]: { padding: '4px' },
      },
      /*
      '@media (max-width: 800px)': {
        marginTop: 0,
        marginRight: 0,
        '& > span': {
          lineHeight: '48px',
        },
      },
      */
      [theme.breakpoints.down('md')]: {
        //marginRight: theme.spacing(4)
      },
      [theme.breakpoints.down('xs')]: {
        marginRight: theme.spacing(0),
      },
    },
    hideEvents: {
      '& .highcharts-plot-line-label': {
        display: 'none',
      },
    },
    /*
    spacerV: {
      order: 1,
      [theme.breakpoints.down('md')]: { display: 'none' },
    },
    */
    info: {
      // alignSelf: 'flex-start',
      /*
      '& > div': {
      },
      */
      //[theme.breakpoints.down('md')]: {
      //order: 0,
      padding: theme.spacing(4, 0),
      margin: theme.spacing(0, -2),
      minWidth: `calc(100% + ${theme.spacing(4)}px)`,

      '& > div > div': {
        alignItems: 'baseline',
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        /*
          '& > div:first-child': {
            minHeight: '4.2rem',
          },
          */
      },
      '& > div:last-child:not(:only-child) > div': {
        paddingLeft: 0,
      },
      //},
      [theme.breakpoints.down('xs')]: {
        padding: 0,
        minWidth: `100%`,
        margin: theme.spacing(0, 0, 2, 0),

        '& > div > div': {
          padding: theme.spacing(1, 1, 0, 1),
          /*
          '& > div:first-child': {
            minHeight: '0',
          },
          */
        },
      },
      '& .yearlyProfit': {
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(0),

        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing(4),
        },

        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(1, 1, 0, 1),
        },
      },
      '& .value': {
        //textAlign: 'right',
        [theme.breakpoints.down('md')]: {
          textAlign: 'left',
          paddingTop: 0,
        },
      },
      '& .profit': {
        //textAlign: 'center',
        padding: theme.spacing(0, 0, 0, 2.25),
        fontSize: '12px',
        '& span ': { fontWeight: 900 },
        '& strong': { fontSize: '22px', fontWeight: 700, marginLeft: theme.spacing(0.5) },
        [theme.breakpoints.down('xs')]: {
          padding: 0,
        },
      },
      '& strong': {
        fontSize: '28px',
        /*
        [theme.breakpoints.down('xs')]: {
          fontSize: '1.8rem',
        },
        */
        fontWeight: '900',
        '& span': {
          fontSize: '1rem',
          color: 'black',
        },
        '&.investments': {
          color: theme.palette.grey[600],
        },
        '&.positive': {
          color: EdwardColors.POSITIVE,
        },
        '&.negative': {
          color: EdwardColors.NEGATIVE,
        },
      },
    },
    title: {
      fontWeight: 600,
      minHeight: '4.2rem',
      padding: `0 !important`,
      '& span': { fontWeight: 400 },
      [theme.breakpoints.down('sm')]: {
        minHeight: 0,
      },
    },
    /*
    spacerH: {
      order: 3,
      padding: theme.spacing(4),
      [theme.breakpoints.down('md')]: { display: 'none' },
    },
    */
    menu: {
      /*
      order: 4,
      [theme.breakpoints.down('md')]: { order: 2 },

      [theme.breakpoints.down('xs')]: {
        padding: '0 8px',
      },
      */
    },
    percentageSwitch: {
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.down('xs')]: {
        marginRight: theme.spacing(0),
      },
    },
    checks: {
      marginBottom: theme.spacing(1),

      '& > div > *': {
        display: 'inline-flex',
      },
      '& > div': {
        width: '210px',
        alignItems: 'center',
        display: 'flex',
      },
      '& svg': {
        display: 'inline-flex',
        padding: '2px',
        border: 'solid #bdbdbd 1px',
        marginRight: theme.spacing(1),
      },
    },
    detailTitle: {
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: '19px',
      },
    },
    drift: {
      fontSize: '20px',
      fontWeight: 800,
      '& > span': { marginLeft: theme.spacing(1) },
      '& .HIGH': { color: EdwardColors.ALERT },
      '& .MID': { color: EdwardColors.DARK },
      '& .LOW': { color: EdwardColors.GREEN },
    },
    bucketMisc: {
      maxWidth: '825px',
      minWidth: '825px',
      margin: '0 auto 16px auto',
      [`@media (max-width: 1200px)`]: {
        minWidth: 'auto',
        padding: '0 8px',
      },
      [theme.breakpoints.down('xs')]: {
        '& > div': {
          textAlign: 'center !important',
          margin: '8px 0'
        }
      },
    },

  }),
);

export const usePortfolioStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainText: {
      fontSize: '19px',
      margin: theme.spacing(4,0),
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px'
      }
    },
  }),
);

export default useStyles;
